
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'

import { HttpInitVsSku, HttpVsSkuList } from '@/service/boss/allot';

import compSearch from './search';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpVsSkuList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'init':
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '批量初始化SKU操作',
                        type,
                    }
                    break;
            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'init': request = HttpInitVsSku; params = { productIds: this.checkedId }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },

    },
    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('diction', ['getNewProductList']),
        columns () {
            return [
                {
                    type: 'selection',
                    width: 60,
                },
                {
                    title: '项目',
                    key: 'lineId',
                    sortable: true,
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewProductList.filter((item) => {
                            return id === item.value
                        })[0] || {};
                        return <span>{product.label}</span>
                    },
                },
                {
                    title: 'ERPSKU',
                    key: 'erpSku',
                    sortable: true,
                }];
        },
    },
};




